
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import  MyDateWidget from '../../components/datePicker/datePicker';

/*Assets*/
import Deals from '../../assets/images/deals.png';

/*Services*/
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';
import APIPost from '../../services/apiCall/post';

class Slot extends Component {
  constructor(props){
    super(props);
    this.state = {
      tabIndex: 1,
      slots: [],
      data: this.props.data ? this.props.data : {},
      selectedSlotIds: [],
      schedules: [],
      date: moment()
    }
  }

  componentDidMount() {
    
    var validityType = this.props.data.adLocation.validity_type;
    var showSlots = false;
    if(validityType===4){
      showSlots = true
    }
    this.setState({showSlots: showSlots});
    if(showSlots){
      this.setState({date: moment().format("DD-MM-YYYY")})
      this.getSlots(moment().format("DD-MM-YYYY"))
    }else{
      this.getDaySlots();
    }

  }

  tabItemClick(tempItem){
    this.setState({tabIndex: tempItem});
  }

  selectChange = async (category) => {
    await this.setState({category: category});
  }

  nextStepClick(){
    var schedules = this.state.schedules;
    if(schedules.length===0){
      if(this.state.selectedSlotIds.length===0){
        return false
      }else{
        var selectedSlots = this.state.slots.filter(this.filterSelected.bind(this))
        // console.log("selectedSlots", selectedSlots)
        var slotArray = []; 
        for (var i = selectedSlots.length - 1; i >= 0; i--) {
          slotArray.push(selectedSlots[i].slot)
        }
        var slotList = slotArray.join(",")
        var currentSchedule = {
          date: this.state.date,
          selectedSlotIds: this.state.selectedSlotIds,
          selectedSlots: selectedSlots,
          slotList: slotList
        };
        schedules.push(currentSchedule);
      }
    }else{
      if(this.state.selectedSlotIds.length){
        var selectedSlots = this.state.slots.filter(this.filterSelected.bind(this))
        // console.log("selectedSlots", selectedSlots)
        var slotArray = []; 
        for (var i = selectedSlots.length - 1; i >= 0; i--) {
          slotArray.push(selectedSlots[i].slot)
        }
        var slotList = slotArray.join(",")
        var currentSchedule = {
          date: slotArray[0],
          selectedSlotIds: this.state.selectedSlotIds,
          selectedSlots: selectedSlots,
          slotList: slotList
        };
        schedules.push(currentSchedule); 
      }
    }
    // var validityType = this.props.data.adLocation.validity_type;
    // var showSlots = false;
    // if(validityType===4){
    //   showSlots = true
    // }
    // showSlots = true
    // console.log("showSlots", showSlots)
    // var schedules = this.state.schedules;
    // if(!showSlots){
    //   if(schedules.length===0){
    //     if(this.state.selectedSlotIds.length===0){
    //       return false
    //     }else{
    //       var selectedSlots = this.state.slots.filter(this.filterSelected.bind(this))
    //       // console.log("selectedSlots", selectedSlots)
    //       var slotArray = []; 
    //       for (var i = selectedSlots.length - 1; i >= 0; i--) {
    //         slotArray.push(selectedSlots[i].slot)
    //       }
    //       var slotList = slotArray.join(",")
    //       var currentSchedule = {
    //         date: this.state.date,
    //         selectedSlotIds: this.state.selectedSlotIds,
    //         selectedSlots: selectedSlots,
    //         slotList: slotList
    //       };
    //       schedules.push(currentSchedule);
    //     }
    //   }else{
    //     if(this.state.selectedSlotIds.length){
    //       var selectedSlots = this.state.slots.filter(this.filterSelected.bind(this))
    //       // console.log("selectedSlots", selectedSlots)
    //       var slotArray = []; 
    //       for (var i = selectedSlots.length - 1; i >= 0; i--) {
    //         slotArray.push(selectedSlots[i].slot)
    //       }
    //       var slotList = slotArray.join(",")
    //       var currentSchedule = {
    //         date: this.state.date,
    //         selectedSlotIds: this.state.selectedSlotIds,
    //         selectedSlots: selectedSlots,
    //         slotList: slotList
    //       };
    //       schedules.push(currentSchedule); 
    //     }
    //   }
    // }else{
    //   if(this.state.date){
    //     var selectedSlots = this.state.slots;
    //     // console.log("selectedSlots", selectedSlots)
    //     var slotArray = []; 
    //     for (var i = selectedSlots.length - 1; i >= 0; i--) {
    //       slotArray.push(selectedSlots[i].slot)
    //     }
    //     var slotList = slotArray.join(",")
    //     var currentSchedule = {
    //       date: this.state.date,
    //       selectedSlotIds: this.state.selectedSlotIds,
    //       selectedSlots: selectedSlots,
    //       slotList: slotList
    //     };
    //     schedules.push(currentSchedule);
    //   }else{
    //     return false
    //   }
    // }


    var data = this.state.data;
    data['schedules'] = schedules;

    this.props.nextStep(data);
  }

  getSlots(date){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'ads/available-slots';
    var data = JSON.stringify({
      booking_date: date,
      ads_location_id: this.props.data.adLocation.id
      // ads_location_id: 6
    });
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        console.log(response.data);
        if(this.state.showSlots){
          this.setState({ slots: response.data});  
        }else{
          this.setState({slotsForDay: response.data });
        }
        
      }
    }.bind(this))
  }

  getDaySlots(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'ads/available-dates';
    var data = JSON.stringify({
      // booking_date: date,
      ads_location_id: this.props.data.adLocation.id
      // ads_location_id: 6
    });
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        console.log(response.data);
        this.setState({ slots: response.data, apiLoading: false });
      }
    }.bind(this))
  }

  dateChanged(date){
    // console.log(date);
    var formattedDate = date.format("DD-MM-YYYY")
    this.setState({date: formattedDate, selectedSlotIds: [], momentDate: date});
    this.getSlots(formattedDate)
  }

  selectSlot(slot_id){
    if(!this.state.showSlots){ this.getSlots(slot_id)}
    var selectedSlotIds = this.state.selectedSlotIds;
    if(selectedSlotIds.includes(slot_id)){
      // already selected, remove
      selectedSlotIds.splice(selectedSlotIds.indexOf(slot_id), 1)
    }else{
      selectedSlotIds.push(slot_id)
    }

    this.setState({selectedSlotIds: selectedSlotIds});
  }

  filterSelected(item){
    // console.log(item)
    var index = this.state.selectedSlotIds.indexOf(item.id);
    if(index!=-1){
      return item
    }

  }

  filterSelectedDays(item){
    // console.log(item)
    var index = this.state.selectedSlotIds.indexOf(item.slot);
    if(index!=-1){
      return item
    }

  }

  async addNewSchedule(){
    if(this.state.selectedSlotIds.length===0){
      return false
    }
    if(this.state.showSlots){
      var schedules = this.state.schedules;
      var selectedSlots = this.state.slots.filter(this.filterSelected.bind(this))
      // console.log("selectedSlots", selectedSlots)
      var slotArray = []; 
      for (var i = selectedSlots.length - 1; i >= 0; i--) {
        slotArray.push(selectedSlots[i].slot)
      }
      var slotList = slotArray.join(",")
      var currentSchedule = {
        date: this.state.date,
        selectedSlotIds: this.state.selectedSlotIds,
        selectedSlots: selectedSlots,
        slotList: slotList
      };
      schedules.push(currentSchedule);
      await this.setState({
        date: undefined,
        slots: [],
        selectedSlotIds: [],
        schedules: schedules
      });
    }else{
      var schedules = this.state.schedules;
      // var selectedSlots = this.state.slots;
      var selectedDays = this.state.slots.filter(this.filterSelectedDays.bind(this));
      console.log("selectedDays", selectedDays);
      var selectedSlots = this.state.slotsForDay;
      // console.log("selectedSlots", selectedSlots)
      var slotArray = []; 
      var slotIdArray = [];
      for (var i = selectedSlots.length - 1; i >= 0; i--) {
        slotArray.push(selectedSlots[i].slot)
        slotIdArray.push(selectedSlots[i].id)
      }
      var slotList = slotArray.join(",")
      for (var i = selectedDays.length - 1; i >= 0; i--) {
        
        var currentSchedule = {
          date: selectedDays[i].slot,
          selectedSlotIds: slotIdArray,
          selectedSlots: selectedSlots,
          slotList: slotList
        };
        schedules.push(currentSchedule);
      }
      await this.setState({
        date: undefined,
        slots: [],
        selectedSlotIds: [],
        schedules: schedules
      })
      
    }
    

    this.nextStepClick();
  }

  render() {

     const filterBy = [
      { value: 1, label: 'Active' },
      { value: 2, label: 'Ongoing' },
      { value: 3, label: 'Completed' },
    ]

    var showSlots = this.state.showSlots;

    console.log("this.state.selectedSlotIds");
                            console.log(this.state.selectedSlotIds);


    return (
      <div className="e-main-content e-vendor-table">
        <h2 className="e-page-head">Create Ad's</h2>

            <div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="e-vendor-category-list e-time-schedule">
                    <div className="row">
                      <h6 className="pl-3 pb-3">Set ad schedule</h6>
                     </div>
                    <div className="row">
                      <div className="col-lg-10">
                        <div className="e-bg-slot">
                        {
                          showSlots?
                            <div className="pt-3 pl-3 e-datePicker">
                              <MyDateWidget date={this.state.momentDate} dateChanged={this.dateChanged.bind(this)}/>
                            </div>
                          :
                            null
                        }
                              
                          <h6 className="pt-4 pl-3">{showSlots ? "Select dates" : this.state.slots.length ? "Select free slots" : "Select a date"}</h6>
                          <div className="row pl-3">
                          {

                            showSlots?
                              this.state.slots.map((slot, index)=>{
                                if(slot.available){
                                  return(
                                    <div 
                                      key={index} 
                                      className={
                                        this.state.selectedSlotIds.includes(slot.id) ? 
                                          "col-md-2 e-time-slot2-active m-2" : 
                                          "col-md-2 e-time-slot2 m-2 "
                                      } 
                                      onClick={this.selectSlot.bind(this, slot.id)}>
                                        {slot.slot}
                                      </div>
                                  )
                                }
                                return(
                                  <div key={index} className="col-md-2 e-time-slot1 m-2 ">{slot.slot}</div>
                                )
                              })
                            :
                              this.state.slots.map((slot, index)=>{
                                if(slot.available){
                                  return(
                                    <div 
                                      key={index} 
                                      className={
                                        this.state.selectedSlotIds.includes(slot.slot) ? 
                                          "col-md-2 e-time-slot2-active m-2" : 
                                          "col-md-2 e-time-slot2 m-2 "
                                      } 
                                      onClick={this.selectSlot.bind(this, slot.slot)}>
                                        {slot.slot}
                                      </div>
                                  )
                                }
                                return(
                                  <div key={index} className="col-md-2 e-time-slot1 m-2">{slot.slot}</div>
                                )
                              })
                          }
                          </div>
                          
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="e-bg-slot p-3">
                          <h5 className="text-center">{this.props.data.adLocation.time_left} {this.props.data.adLocation.validity_type === 1 ? "Days": this.props.data.adLocation.validity_type===2 ? "Months": this.props.data.adLocation.validity_type===3 ? "Years" : "Hours"}</h5>
                          <h6 className="text-center">Time Left</h6>
                        </div>
                      </div>
                    </div>
                    <div className="row pt-3">
                      <div className="col-lg-10">
                      {
                        this.state.selectedSlotIds.length?
                            <React.Fragment>
                              {/* <div className="e-bg-slot text-center">
                                <button class="e-s-btn e-schedule-btn" type="submit" value="Submit" onClick={this.addNewSchedule.bind(this)}>Save & Next</button>
                              </div> */}
                              <button class="e-s-btn" type="submit" value="Submit" onClick={this.addNewSchedule.bind(this)}>Save & Next</button>
                            </React.Fragment>
                        :
                           <button class="e-s-btn e-inactive" type="submit" value="Submit">Save & Next</button>
                      }
                      </div>
                    </div>
                    {/*<div className="row pt-4 ml-1">
                    {
                      this.state.schedules.length?
                        <div className="col-lg-12 pl-0 mb-5">
                          <h6 className="e-ad-type mb-2">Schedules</h6>
                          {
                            this.state.schedules.map((schedule, index)=>{
                              return(
                                <p>{schedule.date}<span className="ml-5">{schedule.slotList}</span></p>
                              )
                            })
                          }
                          <button className="e-s-btn" type="submit" onClick={this.nextStepClick.bind(this)} value="Submit">Next</button>
                        </div>
                      : null
                    }
                    </div>*/}
                </div>
              </div>


            </div>

      </div>
      </div>

    );
  }
}

export default Slot;
